<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5 p-2" style="transform: translateX(-19vw)">
      <div class="d-flex justify-content-between" style="margin: 2vw 0;">
        <h5 style="font-size: 1.3vw !important; margin-right: 2vw;">
          مدیریت مستندات فرآیندی
        </h5>
        <div class="changes">
          <router-link to="/Process/documentation/management">جستجوی سریع</router-link>
          <p href="">نمایش پوشه ای</p>
        </div>
      </div>
      <div class="w-100 p-1">
        <div
            style="background-color: #eee;" class="w-100 min-vh-100 border-2 p-3   "
            @contextmenu.prevent="rightContainerMethod">
          <center>
            <router-link to="/Process/documentation/management/FolderMode" class="root"> </router-link>
          </center>

          <br>
          <div class="d-flex flex-wrap align-items-start justify-content-start">

            <div style="position:relative;" v-for="item in allCategories">
              <Foldor @click.prevent="FolderSettingsMethod(item.id)"
                      @dblclick="NextPage(item.id)" :name="item.title" :title="item.title"/>
              <div class="options" :id="`option_change_${item.id}`"
                   style="background-color: #fff; display: none; width: 8vw; height: 7vw; margin-right: 1vw; position:absolute; top: 5vw; right: 0; border-radius: 1vw">
                <p @click.prevent="edit(item.id)" style="cursor: pointer" class="border-bottom my-3 ">📝ویرایش</p>
                <p @click.prevent="deleteItem(item.id)" style="cursor: pointer">🗑️حذف</p>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top bg-white" style="z-index: 999999999999999; width: 24vw;"
       v-show="rightContainer || editModal || removeModal">
    <div>
      <div class="d-flex flex-nowrap no_print hide">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between ">
              <h2 v-if="rightContainer || editModal" style="font-size: 1.2vw !important;">دسته‌ بندی فرآیند</h2>
              <p v-if="rightContainer" @click.prevent="rightContainer=!rightContainer">❌</p>
              <p v-if="editModal" @click.prevent="editModal=!editModal">❌</p>
            </div>
            <div v-if="removeModal">
              <center>
                آیا می خواهید حدف کنید؟
              </center>
              <br>
            <div class="d-flex align-items-center  ">
              <button   class="btn btn-primary btn-back mx-3" style="height: 2vw;"  type="button" @click="removeModal=!removeModal">
                بازگشت
              </button>
              <button   class="btn btn-primary   btn-submit-1" style="height: 2vw;"  type="button" @click="deleteItemForm(id)">
                بله
              </button>

            </div>
            </div>
            <form v-if="rightContainer || editModal"  class="needs-validation" novalidate>
              <div class="d-flex justify-content-between" style="    width: 19vw;">
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label">عنوان دسته</label>
                  <input class="form-control" v-model="nameCat" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label">عنوان انگلیسی</label>
                  <input class="form-control" v-model="nameCatEn" required>
                </div>
              </div>
              <div v-if="rightContainer" class="col-lg-2 mb-3 ms-n-08" style="width: 20vw;">
                <label class="form-label">سطح زیر مجموعه </label>
                <div class="d-flex w-100 justify-content-between">
                  <label><input class="mx-1" type="checkbox" v-model="is_floor" :value="true"
                                id="">طبقه</label>
                  <label><input class="mx-1" type="checkbox" v-model="is_group" :value="true" id="">گروه</label>
                  <label><input class="mx-1" type="checkbox" v-model="is_process" :value="true" id="">فرآیند</label>
                  <label><input class="mx-1" type="checkbox" v-model="is_subProcess" :value="true" id="">زیر
                    فرآیند</label>
                </div>

              </div>
              <div v-if="is_group || is_process || is_subProcess" class="col-lg-2 mb-3 ms-n-08" style="width: 20vw;">
                <label class="form-label">سطح تعریف شناسنامه </label>
                <div class="d-flex w-100 ">

                  <label class="mx-1" v-if="is_group"><input class="mx-1" type="checkbox" :value="true"
                                                             v-model="is_group_id" id="">گروه</label>
                  <label class="mx-1" v-if="is_process"><input class="mx-1" type="checkbox" :value="true"
                                                               v-model="is_process_id" id="">فرآیند</label>
                  <label class="mx-1" v-if="is_subProcess"><input class="mx-1" type="checkbox" :value="true"
                                                                  v-model="is_subProcess_id" id="">زیر فرآیند</label>
                </div>

              </div>
              <button v-if="rightContainer" class="btn btn-primary   btn-submit-1" style="width: 20vw;" type="button" @click="addCategory">
                افزودن
              </button>
              <button v-if="editModal" class="btn btn-primary   btn-submit-1" style="width: 20vw;" type="button" @click="update(id)">
                ویرایش
              </button>



            </form>


          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- for folder options -->


</template>
<script>

import {defineComponent} from "vue";
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Documents from "@/components/process_documentation_management/Document.vue";
import process from "@/components/process_documentation_management/proccess.vue";
import Organization from "@/components/process_documentation_management/Organization.vue";
import router from "@/router";
import File from "@/components/Docs/File.vue";
import Foldor from "@/components/Docs/Folder.vue";
import {useToast} from "vue-toastification";

const toast = useToast();

export default defineComponent({
  components: {Foldor, File, Documents, Sidebar, Splash, process, Organization},
  data() {

    return {
      allItem: [
        {label: "خط مشی", value: "خط مشی"},
        {label: "آیین نامه", value: "آیین نامه"},
        {label: "نظامنامه", value: "نظامنامه"},
        {label: "روش اجرایی", value: "روش اجرایی"},
        {label: "دستور العمل", value: "دستور العمل"},
        {label: "مدارک طرح ریزی", value: "مدارک طرح ریزی"},
        {label: "فرم ها", value: "فرم ها"},
        {label: "برون سازمانی", value: "برون سازمانی"}
      ],
      allCategories: [],
      categories: [],
      rightContainer: false,
      editModal: false,
      FolderOptionModal: false,
      removeModal: false,
      nameCat: '',
      nameCatEn: '',
      is_floor: false,
      is_group: false,
      is_process: false,
      is_subProcess: false,

      is_group_id: false,
      is_process_id: false,
      is_subProcess_id: false,
      id: '',

    }
  },
  methods: {
    deleteItem(id){
      this.id = id
      this.removeModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.nameCat =  ''
            this.nameCatEn = ''
            this.id = ''
            this.removeModal = false

            this.allItemsCat()
            this.removeAll()



          })
          .catch();

    },
    edit(id){
      this.id = id
      this.editModal = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {



            this.nameCat = result.item.title
            this.nameCatEn = result.item.title_en

          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.nameCat.length) {
        formdata.append('title', this.nameCat)

      }
      if (this.nameCatEn.length) {
        formdata.append('title_en', this.nameCatEn)

      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.nameCat =  ''
            this.nameCatEn = ''
            this.id = ''
            this.editModal = false

            this.allItemsCat()
            this.removeAll()


          })
          .catch();
    },

    NextPage(id) {
      router.push(`/Process/documentation/management/FolderAndFileMode/${id}`)

    },

    removeAll() {
      document.querySelectorAll('.options').forEach((ele) => ele.classList.remove('d-block'))

    },
    FolderSettingsMethod(id) {


      const div = document.querySelector(`#option_change_${id}`)
      if (div.classList.contains('d-block')) {
        div.classList.remove('d-block')

      } else {
      document.querySelectorAll('.options').forEach((ele) => ele.classList.remove('d-block'))
        div.classList.add('d-block')
      }


    },
    addCategory() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('name', this.nameCat);
      formdata.append('title_en', this.nameCatEn);
      formdata.append('is_floor', this.is_floor);
      formdata.append('is_group', this.is_group);
      formdata.append('is_process', this.is_process);
      formdata.append('is_sub_process', this.is_subProcess);
      formdata.append('idcard_group', this.is_group_id);
      formdata.append('idcard_process', this.is_process_id);
      formdata.append('idcard_sub_process', this.is_subProcess_id);


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/processes/store_from_file`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.allCategories.length = 0
            this.allItemsCat()
            this.rightContainerMethod()
            this.nameCat = ''
            this.nameCatEn = ''
            this.is_floor = false
            this.is_group = false
            this.is_process = false
            this.is_subProcess = false
            this.is_group_id = false
            this.is_process_id = false
            this.is_subProcess_id = false
            toast.success('دسته بندی با موفقیت ایجاد شد!')


          })
          .catch();
    },
    rightContainerMethod() {
      if (this.editModal || this.removeModal) return;

      this.rightContainer = !this.rightContainer
    },
    allItemsCat() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_categories`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.allCategories.length = 0
            if (response.all) {
              response.all.forEach((ele) => {
                this.allCategories.push(ele)
              })
            }


          })
          .catch();
    },


    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.allItemsCat()
  },

})
</script>
<style lang="scss" scoped>
.changes {
  background-color: #AFAFAF;
  height: 2vw;
  display: flex;
  width: 18vw;
  border-radius: 1vw;
  justify-content: space-between;
  padding: 1vw;

  & > a {
    color: #000;
    text-decoration: none;
    display: block;
    transform: translateY(-1vw);


  }

  & p {
    width: 8vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    border-radius: 1vw;
    transform: translateY(-1vw) translateX(-1vw);
    display: grid;
    place-items: center;

  }
}

.root {
  background-color: #fff;
  width: 20vw;
  border-radius: 0 0 1vw 1vw;
  display: block;
  text-decoration: none;
  color: #000;
  transform: translateY(-1vw);
}
</style>